/**
 * Extracts the slug from the current URL.
 * Supports multiple URL formats:
 * - Path-based: /collect/slug-name or /collect/slug-name/fr
 * - Query parameter: /collect/pots?id=30465-cagnotte-4-13-22
 *
 * @returns The extracted slug, or an empty string if not found
 */
export const extractSlugFromUrl = (): string => {
	const url = window.location
	const languageCodes = ['fr', 'gb', 'en', 'es', 'pt', 'ie']

	// Check for query parameter format: /collect/pots?id=30465-cagnotte-4-13-22
	const urlParams = new URLSearchParams(url.search)
	const idParam = urlParams.get('id')
	if (idParam) {
		// The entire id parameter value is used as the slug
		return idParam
	}

	// Fallback to path-based extraction
	const pathSegments = url.pathname.split('/').filter(Boolean)

	// Find the index of 'collect' or 'cagnotte' in the path
	const collectIndex = pathSegments.findIndex(
		(segment) => segment === 'collect' || segment === 'cagnotte'
	)

	if (collectIndex !== -1 && collectIndex + 1 < pathSegments.length) {
		const potentialSlug = pathSegments[collectIndex + 1]

		// Check if the next segment is a language code
		if (collectIndex + 2 < pathSegments.length) {
			const nextSegment = pathSegments[collectIndex + 2]
			if (languageCodes.includes(nextSegment)) {
				// URL is /collect/slug/fr format
				return potentialSlug
			}
		}
		// URL is /collect/slug format or slug is the last segment
		return potentialSlug
	}

	// Fallback: return the last segment if no collect/cagnotte found
	return pathSegments[pathSegments.length - 1] || ''
}
